@if (!calledByOtherComponent) {
  <div mat-dialog-title>
    <span>{{'action.configuration' | translate}}</span>
    <button [mat-dialog-close]="data">
      <i class="fa fa-times"></i>
    </button>
  </div>
}

<mat-dialog-content>
  <!-- PART 2 -->
  <div class="">
    @if (!calledByOtherComponent) {
      <h3> {{'users.modal.configuration.import_export' | translate}}</h3>
    }
    @if (calledByOtherComponent) {
      <h3> {{'subscriptions.modal.detail.configuration.utilisateurs_import_export_abonnement' | translate}}</h3>
    }


    <div class="wrap-file-actions">
      <app-file-download (userWantsDownloadEvent)="onUserWantsDownloadEvent($event)" [backendResponse]="backendResponseDownloadedFile"></app-file-download>
      <app-file-upload (userWantsUploadEvent)="onUserWantsUploadEvent($event)" [backendResponse]="backendResponseUploadedFile"></app-file-upload>
    </div>
  </div>
</mat-dialog-content>